import { Component, inject, output, signal } from '@angular/core';

import { faFlag as faSolidFlag } from '@fortawesome/duotone-regular-svg-icons';
import { ContextMenuComponent, ContextMenuItem } from '@akostm/orbit-ui';
import { ActiveConversationEntityState, ConversationHelperService } from '../../../';

@Component({
  selector: 'shared-flag-list',
  standalone: true,
  imports: [ContextMenuComponent],
  templateUrl: './flag-list.component.html',
})
export class FlagListComponent {
  protected readonly solidFlag = faSolidFlag;
  readonly #conversationHelperService = inject(ConversationHelperService);
  conversationData = signal<ActiveConversationEntityState | undefined>(undefined);

  closeDropdown = output();

  items = signal<ContextMenuItem[]>([
    {
      label: 'SHARED.FLAGS.COLORS.ORANGE',
      icon: this.solidFlag,
      iconClass: 'flag flag-orange',
      clickValue: 'orange',
      iconSize: 'xl',
    },
    {
      label: 'SHARED.FLAGS.COLORS.RED',
      icon: this.solidFlag,
      iconClass: 'flag flag-red',
      clickValue: 'red',
      iconSize: 'xl',
    },
    {
      label: 'SHARED.FLAGS.COLORS.PURPLE',
      icon: this.solidFlag,
      iconClass: 'flag flag-purple',
      clickValue: 'purple',
      iconSize: 'xl',
    },
    {
      label: 'SHARED.FLAGS.COLORS.BLUE',
      icon: this.solidFlag,
      iconClass: 'flag flag-blue',
      clickValue: 'blue',
      iconSize: 'xl',
    },
    {
      label: 'SHARED.FLAGS.COLORS.YELLOW',
      icon: this.solidFlag,
      iconClass: 'flag flag-yellow',
      clickValue: 'yellow',
      iconSize: 'xl',
    },
    {
      label: 'SHARED.FLAGS.COLORS.GREEN',
      icon: this.solidFlag,
      iconClass: 'flag flag-green',
      clickValue: 'green',
      iconSize: 'xl',
    },
    {
      divider: true,
    },
    {
      label: 'SHARED.FLAGS.CLEAR',
      clickValue: 'clear',
    },
  ]);

  toggleDropdown() {
    this.closeDropdown.emit();
  }

  async selectColor(value: string) {
    const conversation = this.conversationData();

    if (conversation) {
      if (value == 'clear') {
        const labels = conversation.labels as string[];
        const existingFlagLabel = labels.find((label) => label.includes('flag'));
        if (existingFlagLabel) {
          await this.#conversationHelperService.deleteConversationLabel(
            conversation.id,
            existingFlagLabel
          );
        }
      } else {
        await this.#conversationHelperService.createConversationLabels(
          conversation.id,
          `flag:${value}`
        );
      }
      this.toggleDropdown();
    }
  }
}
